import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <section className="bg-primary-400 py-5">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 px-2">
          <div className="flex justify-center items-center col-span-1 md:col-start-2">
            <nav className="flex gap-3">
              <Link className="text-white text-xs" to="/">
                Home
              </Link>
              <Link className="text-white text-xs" to="/company/about">
                About Us
              </Link>
              <Link className="text-white text-xs" to="/products">
                Products
              </Link>
              <Link className="text-white text-xs" to="/contact-us">
                Contact Us
              </Link>
            </nav>
          </div>
        </div>
        <p className="text-xs text-center text-white pt-3">
          Copyright {currentYear} &copy; Oyoyo Lubricants. Designed by <span className="text-green-600 font-semibold "><a href="https://jedev.vercel.app/" target="_blank">JeDev</a></span>
        </p>
      </Container>
    </section>
  );
};

export default Footer;
